export enum ViewSelectorColor
{
    DARK = 'dark',
    PRIMARY = 'primary'
}

export enum ViewSelectorStyle
{
  FILL = 'fill',
  OUTLINE = 'outline'
}

export type ViewSelectorColorType = ViewSelectorColor.DARK | ViewSelectorColor.PRIMARY;
export type ViewSelectorStyleType = ViewSelectorStyle.FILL | ViewSelectorStyle.OUTLINE;
